import type { FC } from 'react';

import classNames from 'classnames';
import type { SvpAssetAdditional } from '@vgtv/api-client/lib/svp_asset';

import { EditorialHeading } from '../shared/EditorialHeading/EditorialHeading';
import { Slider } from '../../Slider/Slider';
import { AssetVertical } from '../../Asset/AssetVertical/AssetVertical';
import type { ImageSources } from '../../../helpers/images';
import { useAssetItemTracking } from '../../PageComponents/common/useAssetItemTracking';

import * as styles from './EditorialMulti.module.scss';

export interface EditorialMultiProps {
  header?: string;
  content?: string;
  editorImageUrl?: string;
  assets: (SvpAssetAdditional & {
    imageSources: ImageSources;
  })[];
  useVerticalPosters?: boolean;
  pageComponentIndex?: number;
}

const EditorialMulti: FC<EditorialMultiProps> = ({
  header,
  content,
  editorImageUrl,
  assets,
  useVerticalPosters,
  pageComponentIndex,
}) => {
  const { trackAssetClick } = useAssetItemTracking({
    elementType: 'EditorialMulti',
    header,
    pageComponentIndex,
  });

  return (
    <div className={styles.editorialMulti}>
      <EditorialHeading
        imageUrl={editorImageUrl}
        header={header}
        content={content}
        className={styles.editorialHeading}
      />
      <Slider
        className={classNames(styles.slider, {
          [styles.vertical]: useVerticalPosters,
        })}
      >
        {assets.map((asset, idx) => (
          <AssetVertical
            {...asset}
            key={idx}
            onClick={() => trackAssetClick(asset, idx)}
          />
        ))}
      </Slider>
    </div>
  );
};

export { EditorialMulti };
